var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"color":_setup.colorForRating,"small":"","text-color":"black"}},[(_vm.value)?[_vm._v(" "+_vm._s(_vm.value)+" / 5 "),_c('v-icon',{attrs:{"x-small":"","color":"black","right":""}},[_vm._v(" mdi-star ")])]:[_c('span',{staticStyle:{"width":"33px"}},[_vm._v(" - ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }